import { render, staticRenderFns } from "./RootLayout.vue?vue&type=template&id=38cf7cab&scoped=true&"
import script from "./RootLayout.vue?vue&type=script&lang=js&"
export * from "./RootLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cf7cab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/ubq-h5_build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38cf7cab')) {
      api.createRecord('38cf7cab', component.options)
    } else {
      api.reload('38cf7cab', component.options)
    }
    module.hot.accept("./RootLayout.vue?vue&type=template&id=38cf7cab&scoped=true&", function () {
      api.rerender('38cf7cab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/RootLayout.vue"
export default component.exports